import styled from 'styled-components';

export const StyledSearchWrapper = styled.div`
  .ant-input-affix-wrapper {
    display: flex !important;
  }

  input {
    background: white;
  }

  .anticon {
    vertical-align: 0.125em;
  }
`;

export const ViewerSessionsTableWrapper = styled.div`
  flex: 1;
  margin: 0 8px;

  .BaseTable__row-cell {
    .action-bar {
      display: none;
    }

    &:hover {
      .action-bar {
        display: block;
      }
    }
  }
`;

export const ViewerSessionsTableHeader = styled.div`
  height: 50px;
  line-height: 50px;
  position: relative;

  &:first-child .BaseTable__header-cell-text {
    padding-left: 7.5px;
  }

  .BaseTable__header-cell {
    padding-right: 16px;
  }

  .BaseTable__header-cell-text {
    white-space: nowrap;
  }

  .BaseTable__sort-indicator {
    margin-right: 3px;
  }

  & button {
    position: absolute;
    right: 4px;
    top: 10px;
    border: none;
    background: none;
  }

  &:hover button {
    display: inline-block;
  }
`;
